import { z } from "zod";
import { optional } from "./appointments";
import { recordId } from "./contracts";
import { workDayAssignment, workDayRate } from "./daily-work";

const named = z.object({ id: recordId, name: z.string() });

export const rateProfilePayee = z.object({ subcontractor: named.nullable(), worker: named.nullable() });
export type RateProfilePayee = z.infer<typeof rateProfilePayee>;

export const rateProfile = z.object({
  id: recordId,
  payer: named,
  payee: rateProfilePayee,
  service: named,
  hourlyRate: z.number().nullable(),
  updatedAt: z.string(),
});
export type RateProfile = z.infer<typeof rateProfile>;

export const rateProfileListQuery = z.object({
  payer: optional(recordId.toLowerCase()),
  worker: optional(recordId.toLowerCase()),
  subcontractor: optional(recordId.toLowerCase()),
  service: optional(recordId.toLowerCase()),
});
export type RateProfileListQuery = z.infer<typeof rateProfileListQuery>;

export const rateProfileList = z.object({ items: z.array(rateProfile) });
export type RateProfileList = z.infer<typeof rateProfileList>;

export const rateProfileHistoryQuery = rateProfileListQuery;
export type RateProfileHistoryQuery = z.infer<typeof rateProfileHistoryQuery>;

export const rateProfileHistoryEntry = z.object({
  id: recordId,
  service: z.object({ id: recordId.nullable(), name: z.string().nullable() }),
  from: z.number().nullable(),
  to: z.number().nullable(),
  author: z.object({ id: recordId, name: z.string().nullable() }).nullable(),
  at: z.string(),
});
export type RateProfileHistoryEntry = z.infer<typeof rateProfileHistoryEntry>;

export const rateProfileHistory = z.object({ items: z.array(rateProfileHistoryEntry) });
export type RateProfileHistory = z.infer<typeof rateProfileHistory>;

export const rateableServicesQuery = z.object({
  payer: recordId.toLowerCase(),
  worker: recordId.toLowerCase(),
});
export type RateableServicesQuery = z.infer<typeof rateableServicesQuery>;

export const rateableServices = z.object({ items: z.array(named) });
export type RateableServices = z.infer<typeof rateableServices>;

export const rateProfileRequest = z
  .object({
    payer: recordId.toLowerCase(),
    payee: workDayAssignment,
    service: recordId.toLowerCase(),
    hourlyRate: workDayRate.nullable(),
  })
  .strict();
export type RateProfileRequest = z.infer<typeof rateProfileRequest>;
